export default __webpack_public_path__ + "static/media/svgcar.3fced738.svg";